export default {"src":"/_next/static/media/cryptopedia_social_twitter.19a72290.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};